module.exports = __webpack_public_path__ + "static/media/tachometer-fastest.423476f2.svg";